/** Rocket Pool rETH — 1e18-scaled ETH-per-rETH ratio. */
export const RocketRethAbi = [
  {
    name: 'getExchangeRate',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const

/** Rocket Pool deposit pool — instant-burnability buffer. */
export const RocketDepositPoolAbi = [
  {
    name: 'getBalance',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'getExcessBalance',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
